// @generated by protoc-gen-connect-es v1.4.0
// @generated from file penumbra/core/component/dex/v1/dex.proto (package penumbra.core.component.dex.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArbExecutionRequest, ArbExecutionResponse, ArbExecutionsRequest, ArbExecutionsResponse, BatchSwapOutputDataRequest, BatchSwapOutputDataResponse, CandlestickDataRequest, CandlestickDataResponse, CandlestickDataStreamRequest, CandlestickDataStreamResponse, LiquidityPositionByIdRequest, LiquidityPositionByIdResponse, LiquidityPositionsByIdRequest, LiquidityPositionsByIdResponse, LiquidityPositionsByPriceRequest, LiquidityPositionsByPriceResponse, LiquidityPositionsRequest, LiquidityPositionsResponse, SimulateTradeRequest, SimulateTradeResponse, SpreadRequest, SpreadResponse, SwapExecutionRequest, SwapExecutionResponse, SwapExecutionsRequest, SwapExecutionsResponse } from "@buf/penumbra-zone_penumbra.bufbuild_es/penumbra/core/component/dex/v1/dex_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Query operations for the DEX component.
 *
 * @generated from service penumbra.core.component.dex.v1.QueryService
 */
export const QueryService = {
  typeName: "penumbra.core.component.dex.v1.QueryService",
  methods: {
    /**
     * Get the batch clearing prices for a specific block height and trading pair.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.BatchSwapOutputData
     */
    batchSwapOutputData: {
      name: "BatchSwapOutputData",
      I: BatchSwapOutputDataRequest,
      O: BatchSwapOutputDataResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get the precise swap execution used for a specific batch swap.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.SwapExecution
     */
    swapExecution: {
      name: "SwapExecution",
      I: SwapExecutionRequest,
      O: SwapExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get the precise execution used to perform on-chain arbitrage.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.ArbExecution
     */
    arbExecution: {
      name: "ArbExecution",
      I: ArbExecutionRequest,
      O: ArbExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stream all swap executions over a range of heights, optionally subscribing to future executions.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.SwapExecutions
     */
    swapExecutions: {
      name: "SwapExecutions",
      I: SwapExecutionsRequest,
      O: SwapExecutionsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Stream all arbitrage executions over a range of heights, optionally subscribing to future executions.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.ArbExecutions
     */
    arbExecutions: {
      name: "ArbExecutions",
      I: ArbExecutionsRequest,
      O: ArbExecutionsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Query all liquidity positions on the DEX.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.LiquidityPositions
     */
    liquidityPositions: {
      name: "LiquidityPositions",
      I: LiquidityPositionsRequest,
      O: LiquidityPositionsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Query liquidity positions by ID.
     *
     * To get multiple positions, use `LiquidityPositionsById`.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.LiquidityPositionById
     */
    liquidityPositionById: {
      name: "LiquidityPositionById",
      I: LiquidityPositionByIdRequest,
      O: LiquidityPositionByIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Query multiple liquidity positions by ID.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.LiquidityPositionsById
     */
    liquidityPositionsById: {
      name: "LiquidityPositionsById",
      I: LiquidityPositionsByIdRequest,
      O: LiquidityPositionsByIdResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Query liquidity positions on a specific pair, sorted by effective price.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.LiquidityPositionsByPrice
     */
    liquidityPositionsByPrice: {
      name: "LiquidityPositionsByPrice",
      I: LiquidityPositionsByPriceRequest,
      O: LiquidityPositionsByPriceResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Get the current (direct) spread on a trading pair.
     *
     * This method doesn't do simulation, so actually executing might result in a
     * better price (if the chain takes a different route to the target asset).
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.Spread
     */
    spread: {
      name: "Spread",
      I: SpreadRequest,
      O: SpreadResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get historical candlestick data for a given trading pair.
     *
     * Note that this RPC is directional, to get data for both directions, make a second request.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.CandlestickData
     */
    candlestickData: {
      name: "CandlestickData",
      I: CandlestickDataRequest,
      O: CandlestickDataResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Subscribe to candlestick data updates.
     *
     * @generated from rpc penumbra.core.component.dex.v1.QueryService.CandlestickDataStream
     */
    candlestickDataStream: {
      name: "CandlestickDataStream",
      I: CandlestickDataStreamRequest,
      O: CandlestickDataStreamResponse,
      kind: MethodKind.ServerStreaming,
    },
  }
};

/**
 * Simulation for the DEX component.
 *
 * This is a separate service from the QueryService because it's not just a
 * simple read query from the state. Thus it poses greater DoS risks, and node
 * operators may want to enable it separately.
 *
 * @generated from service penumbra.core.component.dex.v1.SimulationService
 */
export const SimulationService = {
  typeName: "penumbra.core.component.dex.v1.SimulationService",
  methods: {
    /**
     * Simulate routing and trade execution.
     *
     * @generated from rpc penumbra.core.component.dex.v1.SimulationService.SimulateTrade
     */
    simulateTrade: {
      name: "SimulateTrade",
      I: SimulateTradeRequest,
      O: SimulateTradeResponse,
      kind: MethodKind.Unary,
    },
  }
};

